﻿import { DefaultGroupFormatter } from "../../Formatters/DefaultGroupFormatter";
import { IStationValueFormatter } from "../../Formatters/IStationValueFormatter";
import { WmoToMetarWeatherFormatter } from "../../Formatters/WmoToMetarWeatherFormatter";
import { IHashData } from "../../IHashData";
import { ILiveDataListener } from "../../ILiveDataListener";
import { IPage } from "../../IPage";
import { MainSite, DisplayTimeType } from "../../MainSite";
import { ParameterGroupInfo, ParameterGroupInfoSet } from "../../ParameterGroupInfoSet";
import { SiteObservations } from "../SiteObservations/SiteObservations";
import { LiveDataSet, LiveDataSetStation, Status } from "../../API/LiveData/LiveDataSet";
import { Station } from "../../Model/Station";
import { TableCell } from "./TableCell";

export class TablePage implements IPage, ILiveDataListener {
    constructor(private mainSite: MainSite) {
    }

    public id: string = 'table';

    private navBarLink: JQuery;

    private openPopups: string[] = [];

    public initialize(): void {
        this.mainSite.liveDataManager.addListener(this);

        this.navBarLink = $('<li></li>').appendTo(this.mainSite.navBar.navLinksLeft);

        $('<a></a>')
            .attr('href', '#')
            .click(() => {
                this.mainSite.changePage(this.id);
                return false;
            })
            .text('Table')
            .appendTo(this.navBarLink);
    }

    private container: JQuery = null;
    private table: JQuery = null;
    private tableBody: JQuery = null;

    private paramGroupInfos: ParameterGroupInfo[];

    private backupParamGroupInfos: { [id: string]: ParameterGroupInfo[] };

    public handleHashChange(hashData: IHashData): boolean {

        if (this.mainSite.selectedRegion.Id == "GOM") {
            this.navBarLink.hide();
        } else {
            this.navBarLink.show();
        }

        if ((hashData.Page === this.id) && (this.mainSite.selectedRegion.Id != "GOM")) {
            this.navBarLink.addClass('active');
            if (!this.container) {
                this.container = $('<div class="container"></div>').appendTo('body');
                this.table = $('<table class="table table-striped table-hover midi_tablePage_main_table midi_common_table"><tbody><tr><td><span class="text-muted"><i class="fa fa-spin fa-refresh"></i> Loading table...</span></td></tr></tbody></table>').appendTo(this.container);
            }
            this.updateTable();
            return true;
        } else {
            this.navBarLink.removeClass('active');
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            return false;
        }
    }

    public liveDataChanged(latestData: LiveDataSet): void {
        this.updateTable();
    }


    private updateTable(): void {
        if (!this.mainSite.liveDataManager.latestData || !this.table) {
            // No data received yet or table does not exist
            return;
        }

        if (this.mainSite.selectedRegion.Id === "GOM") {
            this.paramGroupInfos = [
                ParameterGroupInfoSet.WindDirection_deg,
                ParameterGroupInfoSet.WindSpeed_kts,
                ParameterGroupInfoSet.GustSpeed_kts,
                ParameterGroupInfoSet.AirTemperature_degC,
                ParameterGroupInfoSet.DewPoint_degC,
                ParameterGroupInfoSet.QNH_mbar,
                ParameterGroupInfoSet.First_CloudCover,
                ParameterGroupInfoSet.First_CloudBaseHeight_ft,
                ParameterGroupInfoSet.Visibility_m,
                ParameterGroupInfoSet.PresentWeather,
                ParameterGroupInfoSet.Hs_m,
                ParameterGroupInfoSet.Tp_s
            ];

            this.backupParamGroupInfos = {};

        } else {
            this.paramGroupInfos = [
                ParameterGroupInfoSet.WindDirection_deg,
                ParameterGroupInfoSet.WindSpeed_kts,
                ParameterGroupInfoSet.GustSpeed_kts,
                ParameterGroupInfoSet.AirTemperature_degC,
                ParameterGroupInfoSet.DewPoint_degC,
                ParameterGroupInfoSet.QNH_mbar,
                ParameterGroupInfoSet.First_CloudCover,
                ParameterGroupInfoSet.First_CloudBaseHeight_ft,
                ParameterGroupInfoSet.Visibility_m,
                ParameterGroupInfoSet.PresentWeather,
                ParameterGroupInfoSet.Hs_m,
                ParameterGroupInfoSet.Tz_s
            ];

            this.backupParamGroupInfos = {};
            this.backupParamGroupInfos[ParameterGroupInfoSet.Tz_s.Id] = [ParameterGroupInfoSet.T2_s];
        }
        
        this.table.empty();

        // build the header
        var headerRow: JQuery = $('<tr class="midi_tablePage_main_table_header"></tr>');
        var periodsRow: JQuery = $('<tr class="midi_tablePage_main_table_periods"></tr>');
        var unitsRow: JQuery = $('<tr class="midi_tablePage_main_table_units"></tr>');

        $('<thead></thead')
            .append(headerRow)
            .append(periodsRow)
            .append(unitsRow)
            .appendTo(this.table);


        headerRow.append($('<th></th>')
            .text('Station'));

        unitsRow.append($('<th></th>')
            .text(''));

        periodsRow.append('<th></th>');

        headerRow.append($('<th></th>')
            .text('Obs. Time'));

        var timeZoneString;

        timeZoneString = this.mainSite.getTimeZoneString();

        periodsRow.append($('<th></th>'));

        unitsRow.append($('<th></th>')
            .text(timeZoneString));


        var periods = [];
        let unitsConverter = MainSite.getUnitConverter();
        this.paramGroupInfos.forEach((paramGroupInfo: ParameterGroupInfo) => {
            var headerCell = $('<th></th>')
                .text(paramGroupInfo.ShortName)
                .attr('title', paramGroupInfo.Description)
                .appendTo(headerRow);

            var unitsCell = $('<th></th>').appendTo(unitsRow);

            if (paramGroupInfo.Units) {
                unitsCell.text(unitsConverter.getConvertedUnits(paramGroupInfo.Units, paramGroupInfo.Id));
            }

            periods.push("");
        });

        $('<tbody class="midi_tablePage_main_table_body">').appendTo(this.table);

        var stationsOrdered: LiveDataSetStation[] = [];
        for (let stationId in this.mainSite.liveDataManager.latestData.Stations) {
            stationsOrdered.push(this.mainSite.liveDataManager.latestData.Stations[stationId]);
        }
        stationsOrdered.sort((a, b) => {
            if (a.Station.RegionOrder < b.Station.RegionOrder) {
                return -1;
            } else if (a.Station.RegionOrder > b.Station.RegionOrder) {
                return 1;
            } else {
                return b.Station.Latitude - a.Station.Latitude;
            }
        });

        stationsOrdered.forEach(_station => {
            var station = _station.Station;

            if (station.Region !== this.mainSite.selectedRegion.Id) return;

            if (station.SpaceAboveInTable) {
                $('<tr class="midi_table-spacer"><td colspan="14"></td></tr>').appendTo(this.table);
            }

            var row = $('<tr data-siteid="' + station.Id + '"></tr>').appendTo(this.table);

            ((station: Station) => {
                row.append($('<td class= "midi_tablePage_main_table_body_small" ></td>')
                    .text(station.Label)
                    .attr('title', 'Click for ' + station.Label + ' station overview page')
                    .click((e: JQueryEventObject) => {
                        this.mainSite.changePage('siteObs', {
                            Station: station.Id,
                            Tab: SiteObservations.getLandingPageId(station)
                        });
                    })
                );
            })(station)

            var obsTimeCell = $('<td class="midi_tablePage_main_table_obstime midi_tablePage_main_table_body_small"></td>').appendTo(row);
            var mostRecentTimeStamp: number = null;

            this.paramGroupInfos.forEach((paramGroupInfo: ParameterGroupInfo, index: number) => {
                let id = paramGroupInfo.Id;
                let valueFormatter: IStationValueFormatter = new DefaultGroupFormatter(paramGroupInfo);

                if (paramGroupInfo.Id === ParameterGroupInfoSet.PresentWeather.Id) {
                    valueFormatter = new WmoToMetarWeatherFormatter();
                }

                let valueObject = valueFormatter.format(this.mainSite.liveDataManager.latestData.Stations[station.Id], this.mainSite.selectedWarningRules);

                if (valueObject.Status === null && paramGroupInfo.Id in this.backupParamGroupInfos) {
                    // parameter does not exist for this station
                    this.backupParamGroupInfos[paramGroupInfo.Id].some(x => {
                        const _valueFormatter = new DefaultGroupFormatter(x);
                        const _valueObject = _valueFormatter.format(this.mainSite.liveDataManager.latestData.Stations[station.Id], this.mainSite.selectedWarningRules);

                        if (_valueObject.Status !== null) {
                            // we have found a suitable backup parameter. we will keep the rules from the primary parameter.
                            valueFormatter = _valueFormatter;
                            valueObject = _valueObject;
                            id = x.Id;
                            return true;
                        }
                    });
                }

                const cell = new TableCell(this.mainSite, row, valueFormatter, station, valueObject, this.openPopups);

                if (valueObject.Status == Status.Good || valueObject.Status == Status.Expiring) {
                    var timeStamp = this.mainSite.liveDataManager.latestData.Stations[station.Id].GroupValues[id][0].Timestamp;
                    if (!mostRecentTimeStamp || timeStamp < mostRecentTimeStamp) {
                        mostRecentTimeStamp = timeStamp;
                    }

                    // only look at averaging periods of values which are displayed
                    if (valueObject.ParameterDefinition) {
                        var suffix = valueObject.ParameterDefinition.Suffix;
                        if (periods[index] === "") { // initial value is ""
                            periods[index] = suffix;
                        } else if (suffix !== periods[index]) {
                            periods[index] = null;
                        }
                    }
                }
            });

            if (mostRecentTimeStamp != null) {
                switch (this.mainSite.displayTimeType) {
                    case DisplayTimeType.UTC:
                        obsTimeCell.text(moment.utc(mostRecentTimeStamp).format("HH:mm").toString());
                        break;
                    case DisplayTimeType.PcTime:
                        obsTimeCell.text(moment(moment.utc(mostRecentTimeStamp)).tz(moment.tz.guess()).format("HH:mm"));
                        break;
                    case DisplayTimeType.StationRegionTime:
                        obsTimeCell.text(moment(moment.utc(mostRecentTimeStamp)).tz(station.TimeZone).format("HH:mm"));
                        break;
                    default:
                }
            }
        });

        periods.forEach(period => {
            var cell = $('<th>');
            if (period) {
                cell.text(period);
            }
            periodsRow.append(cell);
        });

        $('</tbody>').appendTo(this.table);
    }
}